import { AnalyticsEventsPair, makeEventsPair } from "./AnalyticsEventBuilder";
import { Game } from "../../models/Game";
import { GeneralAnalyticsAi } from "./AI/GeneralAnalyticsAi";

export class GeneralAnalytics {
  aiAnalytics = new GeneralAnalyticsAi();

  promoBox(categories: string): AnalyticsEventsPair {
    return makeEventsPair(null, this.aiAnalytics.promoBox(categories));
  }

  promoBoxSlot(
    game: Game,
    promoBoxSlotTitle: string,
    position: number
  ): AnalyticsEventsPair {
    return makeEventsPair(
      null,
      this.aiAnalytics.promoBoxSlot(game, promoBoxSlotTitle, position)
    );
  }

  topNavClick(category: string, index: number): AnalyticsEventsPair {
    return makeEventsPair(null, this.aiAnalytics.topNavClick(category, index));
  }

  displayAd(refresh: boolean): AnalyticsEventsPair {
    return makeEventsPair(null, this.aiAnalytics.displayAd(refresh));
  }

  searchBoxStart(): AnalyticsEventsPair {
    return makeEventsPair(null, this.aiAnalytics.searchBoxStart());
  }

  searchBoxQuery(searchText: string): AnalyticsEventsPair {
    return makeEventsPair(null, this.aiAnalytics.searchBoxQuery(searchText));
  }

  searchBoxSelect(searchText: string, game: Game): AnalyticsEventsPair {
    return makeEventsPair(
      null,
      this.aiAnalytics.searchBoxSelect(searchText, game)
    );
  }

  yellowBanner(id: string, isTheaterMode: boolean): AnalyticsEventsPair {
    return makeEventsPair(
      null,
      this.aiAnalytics.yellowBanner(id, isTheaterMode)
    );
  }

   webVitals(metrics: Record<string, string>): AnalyticsEventsPair {
    return makeEventsPair(null, this.aiAnalytics.webVitals(metrics));
  }
}
